import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

const countries = [
  { countryName: 'BEN', countryCode: '229' },
  { countryName: 'BFA', countryCode: '226' },
  { countryName: 'CMR', countryCode: '237' },
  { countryName: 'CIV', countryCode: '225' },
  { countryName: 'COD', countryCode: '243' },
  { countryName: 'GAB', countryCode: '241' },
  { countryName: 'GHA', countryCode: '233' },
  { countryName: 'KEN', countryCode: '254' },
  { countryName: 'MWI', countryCode: '265' },
  { countryName: 'MOZ', countryCode: '258' },
  { countryName: 'NGA', countryCode: '234' },
  { countryName: 'COG', countryCode: '242' },
  { countryName: 'RWA', countryCode: '250' },
  { countryName: 'SEN', countryCode: '221' },
  { countryName: 'SLE', countryCode: '232' },
  { countryName: 'TZA', countryCode: '255' },
  { countryName: 'UGA', countryCode: '256' },
  { countryName: 'ZMB', countryCode: '260' },
]

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function capitalizeFirstLetter(word: string) {
  if (!word)
    return ''
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
}

export function money(amount: string | number, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency ?? 'USD',
  }).format((amount as number) || 0)
}

export function getCountryCode(countryName: string): string {
  const country = countries.find(c => c.countryName === countryName)
  return country ? country.countryCode : 'Country not found'
}

export function formatMoney(amount: string | number): string {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount) || 0)
}

export function formatText(text: string): string {
  return text
    .replace(/[^a-z0-9 ]/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export function formatCurrency(amount: number, currency: string) {
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)
}

export function formatAmount(amount: string | number, includeDecimals = true): string {
  const numAmount = Number.parseFloat(String(amount)) || 0
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: includeDecimals ? 2 : 0,
    maximumFractionDigits: includeDecimals ? 2 : 0,
  }).format(numAmount)
}
